import { useNetwork } from '@/presentation/context/network';
import { useRouter } from 'next/navigation';
import VaultIcon from '../../elements/VaultIcon';
import Price from '../../elements/Price';
import { LiquidityPool } from 'nftx.js';
import { Address } from 'viem';
import FormattedEther from '../../elements/FormattedEther';

const TokensTableItem = ({
  id,
  index,
  symbol,
  name,
  totalValueLocked,
  pools,
  vaultId,
}: {
  index: number;
  symbol: string;
  name: string;
  totalValueLocked: bigint;
  pools: LiquidityPool[];
  id: Address;
  vaultId: string;
}) => {
  const { push } = useRouter();
  const { slug } = useNetwork();
  const apr = pools
    .map((pool) => pool.apr['1m'])
    .reduce((max, apr) => (apr > max ? apr : max), 0n);

  return (
    <tr
      className="cursor-pointer hover:bg-gray-200"
      onClick={() => push(`/${slug}/info/tokens/${id}`)}
    >
      <td className="px-3 py-4">{index + 1}</td>
      <td className="px-3 py-4">
        <div className="space-x-2 flex items-center">
          <VaultIcon
            vaultId={vaultId}
            className="w-6 h-6 flex-none"
            alt={symbol}
          />
          <span className="">{symbol}</span>
          <span
            className={`py-0.5 px-1.5 rounded-md bg-gray-300 text-sm font-medium truncate`}
          >
            {name}
          </span>
        </div>
      </td>
      <td className="px-3 py-4 text-right">
        <FormattedEther value={apr} style="percent" maximumFractionDigits={2} />
      </td>
      <td className="px-3 py-4 text-right">
        <Price value={totalValueLocked} />
      </td>
      <td className="px-3 py-4 text-right">
        <Price
          showEmpty
          value={pools.reduce((total, pool) => total + pool.dailyVolume, 0n)}
        />
      </td>
      <td className="px-3 py-4 text-right">
        <Price
          showEmpty
          value={pools.reduce((total, pool) => total + pool.weeklyVolume, 0n)}
        />
      </td>
      <td className="px-3 py-4 text-right">{pools?.length}</td>
    </tr>
  );
};

export default TokensTableItem;
